"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubscriptionType = void 0;
exports.ESubscriptionType = {
    legalPerson: "legalPerson",
    naturalPerson: "naturalPerson",
    coSubscriptionNaturalPerson: "coSubscriptionNaturalPerson",
};
